import type { ActionItem } from '@/types/entities'

/** Does this action item belong to the signed-in user? New tasks carry
 *  ownerEmail (durable key); seed items only have the display name. */
export function isOwnedBy(a: ActionItem, email: string, displayName: string): boolean {
  if (a.ownerEmail) return a.ownerEmail.toLowerCase() === email.toLowerCase()
  return !!a.owner && a.owner === displayName
}
